import React, { Component } from "react";
import "./Achievement.css";
import AchievementCard from "../../components/achievementCard/AchievementCard";
import { achievementSection } from "../../portfolio";

class Achievement extends Component {
  render() {
    const theme = this.props.theme;

    if (
      !achievementSection ||
      !achievementSection.achievementsCards ||
      achievementSection.achievementsCards.length === 0
    ) {
      return null;
    }

    return (
      <div className="main" id="achievements">
        {achievementSection.achievementsCards.map((detail, idx) => {
          if (detail.Section && Array.isArray(detail.Section)) {
            return (
              <div className="achievement-main-div" key={idx}>
                {detail.heading && (
                  <div className="achievement-header">
                    <h1
                      className="heading achievement-heading"
                      style={{ color: theme ? theme.text : "#000" }}
                    >
                      {detail.heading}
                    </h1>
                    {detail.description ? (
                      <p className="subTitle achievement-subtitle">
                        {detail.description}
                      </p>
                    ) : null}
                  </div>
                )}
                <div className="achievement-cards-div">
                  {detail.Section.map((card, i) => (
                    <AchievementCard
                      key={i}
                      cardInfo={{
                        title: card.title,
                        description: card.subtitle,
                        image: card.image,
                        alt_name: card.alt_name,
                        footer: card.footerLink,
                      }}
                      theme={theme}
                    />
                  ))}
                </div>
              </div>
            );
          }

          // Flat card format
          return (
            <div className="achievement-cards-div" key={idx}>
              <AchievementCard
                cardInfo={{
                  title: detail.title,
                  description: detail.subtitle,
                  image: detail.image,
                  alt_name: detail.imageAlt || detail.alt_name,
                  footer: detail.footerLink,
                }}
                theme={theme}
              />
            </div>
          );
        })}
      </div>
    );
  }
}

export default Achievement;
